import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEditPersonalPage = {
  alert: {
    error: 'applicant-edit-personal.form.alert.error',
  },
  footer: {
    root: 'applicant-edit-personal.footer.root',
  },
  form: {
    cancelButton: 'applicant-edit-personal.form.cancel-button',
    emailAddressInput: 'applicant-edit-personal.form.email-address-input',
    emailAddressInputError:
      'applicant-edit-personal.form.email-address-input-error',
    firstNameInput: 'applicant-edit-personal.form.first-name-input',
    firstNameInputError: 'applicant-edit-personal.form.first-name-input-error',
    h1: 'applicant-edit-personal.form.h1',
    h2: 'applicant-edit-personal.form.h2',
    lastNameInput: 'applicant-edit-personal.form.last-name-input',
    lastNameInputError: 'applicant-edit-personal.form.last-name-input-error',
    phoneInputDisabled: 'applicant-edit-personal.form.phone-input',
    root: 'applicant-edit-personal.form.root',
    submitButton: 'applicant-edit-personal.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-edit-personal.header.drawer-button',
    previousStepButton: 'applicant-edit-personal.header.previous-step-button',
    root: 'applicant-edit-personal.header.root',
  },
  progress: {
    root: 'applicant-edit-personal.progress.root',
  },
} as const satisfies PageLocatorMap;
